module.exports = __webpack_public_path__ + "static/media/pauseSmall.8d86b3a8.svg";